<app-header></app-header>
<div class="pg-wrp">
    <div class="container">
        <div class="row">
          <div class="col-lg-12">
              <div class="src-sec">
                 <div class="sec-txt">
                   <a  routerLink="/customer/my-assistant"><img src="../../../assets/images/Back Arrow.png"></a>
                   <li>
                    <a routerLink="/customer/home">{{'Home'|translate}}</a>
                    <a routerLink="/customer/my-assistant" class="ml-0"> > {{'My Assitant'|translate}}</a>
                    <a class="ml-0"> > {{'Service Request'|translate}}</a>
                  </li>
                 </div>
                 <div class="inp-sec">
                    <!-- <input type="text" placeholder="Search Parts Here..." value="">
                    <div class="src-div">
                        <a><img src="../../../assets/images/search-img.png"></a>
                    </div> -->
                 </div>
              </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  py-gy ">
              <div class="lod-sec col-lg-8">
                  <div class="lod-sec-img">
                      <!-- <img src="../../../assets/images/lod-img.png"> -->
                      <img [src]="fleet_detail['myfleets']['imageWeb']"  onerror="this.src='../../../assets/images/no-image.png'">
                  </div>
                  <div class="lod-sec-txt">
                      <h1><span>{{currentParams.id1}}</span> {{currentParams.id2}}</h1>
                      <p>{{'Serial'|translate}}:<span>{{currentParams.id3}}</span></p>
                      <p><span></span></p>
                      <p><span></span></p>
                      <div class="btn-sec py-btn">
                           <!-- <button><a>Raise Service Request</a></button> -->
                      </div>
                  </div>
              </div>
              <div class="create-incident-par">
           <form #f="ngForm" [formGroup]="createTicket" (ngSubmit)="createTicket.valid && createTickets()">
              <div class="lod-sec col-lg-8">
                <div class="row w-100">
                  <div class="col-lg-6 col-sm-12 col-xs-12">
                      <div class="py-inp-sec">
                    
                        <label>{{'Service Request Type'|translate}}                     
                          *</label>
                        <select class="py-sel" formControlName="requestType">
                          
                          <option selected disabled value="">---{{'SELECT REQUEST'|translate}}---</option>
                          <option *ngFor="let list of requestList" value={{list. }}>{{list.service}}</option>

                        </select>
 
                        <div class="er-msg" *ngIf="f.submitted && createTicket.controls.requestType.errors?.required">Please Select Service Request Type*</div>
                      </div>
                  </div>
                  <div class="col-lg-6 col-sm-12 col-xs-12">
                    <div class="py-inp-sec">
                      <label>{{'Subject'|translate}} *</label>
                      <input type="text" placeholder="Subject"  formControlName="subject">
                      <div class="er-msg" *ngIf="f.submitted && createTicket.controls.subject.errors?.required">Subject Required *</div>
                   </div>
                  </div>
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <div class="py-inp-sec">
                      <label>{{'Description'|translate}} *</label>
                      <textarea type="text" placeholder="{{'Description'| translate}}"  formControlName="description"></textarea>
                        <div class="er-msg" *ngIf="f.submitted && createTicket.controls.description.errors?.required">Description Required *</div>

                   </div>
                  </div>

                  <div class="col-lg-6 col-sm-12 col-xs-12"   >
                    <div class="py-inp-sec" >
                      <label>{{'Service Request Date'|translate}} *</label>





                      <ejs-datetimepicker  format='dd/MM/yyyy'  id='datetimepicker' placeholder='Select a date'  [min]="dateValue"formControlName="reqDate"></ejs-datetimepicker>
 
                      <!-- <input type="text" placeholder="Equipment Standard on Fulfill" value="Equipment Standard on Fulfill">
                      <span (click)="open(mymodal)"> -->
                      <!-- <input type="text" placeholder="Equipment Standard on Fulfill" > -->

                      <!-- <input type="datetime-local" name="user_dateTime"> -->
                      <!-- <dp-date-picker  theme="dp-material" mode='daytime' [config]='config'

                      #datePicker>
                   </dp-date-picker> -->



                    <!-- <input type='text'  id='datetimepicker1' (click)="cal()"/> -->
                    <!-- <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar"></span>
                    </span>
                -->

                      <!-- <input type="date" name="user_dateTime"  	formControlName="reqDate" id="dateInput"  (keydown)="restricts($event)">  -->
                      <!-- <div class="er-msg" *ngIf="f.submitted && createTicket.controls.reqDate.errors?.required">Date And Time Required *</div>
                        <input type="time"> -->
                      <!-- <dp-day-time-calendar  formControlName="reqDate" [config]="datePickerConfig" theme="dp-material"></dp-day-time-calendar>   -->
                      <span>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.99475 6.58984C8.11792 6.58984 6.59082 8.11694 6.59082 9.99393C6.59082 11.8708 8.11792 13.3979 9.99475 13.3979C11.8717 13.3979 13.3988 11.8708 13.3988 9.99393C13.3988 8.11694 11.8717 6.58984 9.99475 6.58984Z" fill="#FFFFFF"/>
                          <path d="M19.4142 9.40794H17.2636C16.9796 5.85311 14.1354 3.00872 10.5804 2.72491V0.585784C10.5804 0.262298 10.3181 0 9.99464 0C9.67115 0 9.40886 0.262298 9.40886 0.585784V2.72491C5.85387 3.00872 3.00964 5.85311 2.72567 9.40794H0.585784C0.262298 9.40794 0 9.67024 0 9.99388C0 10.3174 0.262298 10.5797 0.585784 10.5797H2.72567C3.00964 14.1345 5.85387 16.9789 9.40886 17.2628V19.4018C9.40886 19.7253 9.67115 19.9876 9.99464 19.9876C10.3183 19.9876 10.5804 19.7253 10.5804 19.4018V17.2628C14.1354 16.9789 16.9798 14.1345 17.2636 10.5797H19.4142C19.7377 10.5797 20 10.3174 20 9.99388C20 9.67024 19.7377 9.40794 19.4142 9.40794ZM9.99464 16.1148C6.61956 16.1148 3.87374 13.3688 3.87374 9.99388C3.87374 6.61879 6.61956 3.87283 9.99464 3.87283C13.3697 3.87283 16.1155 6.61879 16.1155 9.99388C16.1155 13.3688 13.3697 16.1148 9.99464 16.1148Z" fill="#FFFFFF"/>
                          </svg>
                      </span>
                   </div>


                  </div>

                  <!-- <div class="col-lg-6 col-sm-12 col-xs-12">
                    <div class="py-inp-sec">
                      <label>Service Request Type</label>
                      <input type="text" placeholder="Equipment Standard on Fulfill">
                      <span>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.99475 6.58984C8.11792 6.58984 6.59082 8.11694 6.59082 9.99393C6.59082 11.8708 8.11792 13.3979 9.99475 13.3979C11.8717 13.3979 13.3988 11.8708 13.3988 9.99393C13.3988 8.11694 11.8717 6.58984 9.99475 6.58984Z" fill="#FFFFFF"/>
                          <path d="M19.4142 9.40794H17.2636C16.9796 5.85311 14.1354 3.00872 10.5804 2.72491V0.585784C10.5804 0.262298 10.3181 0 9.99464 0C9.67115 0 9.40886 0.262298 9.40886 0.585784V2.72491C5.85387 3.00872 3.00964 5.85311 2.72567 9.40794H0.585784C0.262298 9.40794 0 9.67024 0 9.99388C0 10.3174 0.262298 10.5797 0.585784 10.5797H2.72567C3.00964 14.1345 5.85387 16.9789 9.40886 17.2628V19.4018C9.40886 19.7253 9.67115 19.9876 9.99464 19.9876C10.3183 19.9876 10.5804 19.7253 10.5804 19.4018V17.2628C14.1354 16.9789 16.9798 14.1345 17.2636 10.5797H19.4142C19.7377 10.5797 20 10.3174 20 9.99388C20 9.67024 19.7377 9.40794 19.4142 9.40794ZM9.99464 16.1148C6.61956 16.1148 3.87374 13.3688 3.87374 9.99388C3.87374 6.61879 6.61956 3.87283 9.99464 3.87283C13.3697 3.87283 16.1155 6.61879 16.1155 9.99388C16.1155 13.3688 13.3697 16.1148 9.99464 16.1148Z" fill="#FFFFFF"/>
                          </svg>
                      </span>
                   </div>
                  </div> -->

                  <div class="btn-sec">
                    <button class="cre-btn" type="submit"><a>{{'Create Service Request'|translate}}</a></button>
                  </div>

                </div>
              </div>
            </form>
          </div>
          </div>

        </div>
    </div>
</div>
<ng-template #mymodal let-modal>
  <!-- insert map -->
  <!-- using a responsive iframe -->
  <div class="responsive-map-container">
    <!-- place the iframe code between here... -->
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1737.6221882978507!2d-98.48650795000005!3d29.421653200000023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c58aa57e6a56f%3A0xf08a9ad66f03e879!2sHenry+B.+Gonzalez+Convention+Center!5e0!3m2!1sen!2sus!4v1393884854786" width="600" height="450" frameborder="0" style="border:0"></iframe>
    <!-- ... and here -->
  </div>
  <!-- /insert map -->

</ng-template>
<app-footer></app-footer>


    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fcba13" type="ball-atom" [fullScreen]="true">
      <div style="color: white;" *ngIf="isConfirming">Please wait order is confirming..</div>
    
    </ngx-spinner>